import { DELIVERY_STATUS_DATA } from '../actions/actionType'

const initialState = {
  statusList: [],
}
export default function DeliveryStatusReducer(state = initialState, action) {
  switch (action.type) {
    case DELIVERY_STATUS_DATA:
      return { ...state, statusList: action.payload }
    default:
      return state
  }
}
